import { actions } from "../../utils/constants";

const initialState = {
  data: {},
  testStarted: false,
  test_data: {},
};
const oscillaReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.SET_OSCILLA_PATIENT_DETAILS:
      return { ...state, data: action.value };
    case actions.TEST_OSCILLA_PATIENT_DETAILS:
      return { ...state, test_data: action.value };
    case actions.START_OSCILLA_LOADING_VALUES:
      return { ...state, testStarted: action.value };
    default:
      return { ...state };
  }
};

export default oscillaReducer;
